import styled from '@emotion/styled';
import { colors, fontSizes, fontWeights, gutterSizes } from '../base/theme';

export const DetailExpandableListWrapper = styled.div`
    width: 100%;
    padding: ${gutterSizes.large40} 0;
    border-top: 1px solid ${colors.newBorder};
`;

export const ListTitle = styled.h3`
    margin: 0 0 ${gutterSizes.large} 0;
    font-size: ${fontSizes.xlarge};
    font-weight: ${fontWeights.bold};
    color: ${colors.bark};
`;

export const ShowMoreButton = styled.button`
    background: none;
    border: none;
    color: ${colors.navy};
    font-weight: ${fontWeights.bold};
    cursor: pointer;
    padding: ${gutterSizes.medium} 0;
    margin-top: ${gutterSizes.large20};
    display: flex;
    align-items: center;
    
    &:hover {
        text-decoration: underline;
    }
`;
